/* 
    @description  权限和用户相关信息存放
    @autor        shuxiaokai
    @create       2019-07-26 17:42"
*/



export default {
    state: {

    },

    mutations: {

    }



}
